import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export interface TrustBarProps {
  stats: { value: string; label: string }[];
}

export default function TrustBar({ stats }: TrustBarProps) {
  const { ref, visible } = useScrollAnimation(0.1);

  return (
    <section className="relative bg-jc-charcoal z-10 -mt-0 overflow-hidden">
      {/* Gold top border */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-jc-gold to-transparent w-full"></div>

      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-10 py-0">
        <div className="grid grid-cols-2 md:grid-cols-5 divide-y md:divide-y-0 md:divide-x divide-white/6">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-center py-7 md:py-9 md:px-6 text-center"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(16px)',
                transition: `opacity 0.5s ease ${i * 0.08}s, transform 0.5s ease ${i * 0.08}s`,
              }}
            >
              <span className="font-serif text-[2.2rem] md:text-[2.6rem] font-light text-jc-gold leading-none tracking-tight">
                {stat.value}
              </span>
              <span className="text-[9.5px] font-semibold tracking-[0.18em] uppercase text-white/35 mt-2.5">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Award badges strip */}
      <div className="border-t border-white/6 py-4">
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {[
            { icon: 'ri-award-fill', text: 'Thumbtack Best of 2016' },
            { icon: 'ri-award-fill', text: 'Thumbtack Best of 2017' },
            { icon: 'ri-shield-check-fill', text: 'American Personal Chef Association' },
            { icon: 'ri-group-fill', text: 'eWomenNetwork Member' },
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-white/30">
              <i className={`${badge.icon} text-jc-gold/60 text-sm`}></i>
              <span className="text-[10px] font-semibold tracking-widest uppercase">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
